import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { filter, take, map } from "rxjs/operators";
import { UserService } from "./users/user.service";
import { Router } from "@angular/router";
import { ROUTE_ACCESS_RULES, UserRole } from "./auth/route-access-rules";

@Injectable({
  providedIn: "root",
})
export class MiddlewareGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const routePath =
      next.routeConfig && next.routeConfig.path ? next.routeConfig.path : "";
    const routeKey = routePath ? routePath.split("/:")[0] : "";

    const allowedRoles = ROUTE_ACCESS_RULES[routeKey];

    if (!allowedRoles) return of(true);

    return this.userService.currentuserAvailable.pipe(
      filter((available) => !!available),
      take(1),
      map(() => {
        const currentUserRole = this.getCurrentUserRole();
        if (currentUserRole && allowedRoles.includes(currentUserRole))
          return true;
        this.router.navigateByUrl("/Dashboard");
        return false;
      }),
    );
  }

  private getCurrentUserRole(): UserRole | null {
    const user = this.userService.currentUser;
    return user && user["type"] ? (user["type"] as UserRole) : null;
  }
}
